@if (visible) {
  <div class="loading-overlay" [class.loading-overlay--inline]="!fullScreen">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
}
